export const ActionSetDonationDetails = async ({ commit }, form) => {
  const donation_details = form;
  commit("SET_donation", donation_details);
};
